import React  from 'react';
import {  Box, RadioButton, Text } from '@common-fe/common-fe';

import { useCurrentOrganization } from '@/modules/core/hooks';
import { RoleLevel } from '@/modules/role/role.types';

import RoleLevelLabel from './RoleLevelLabel';

interface Props {
  isEditMode?: boolean;
  disabled?: boolean;
  value: RoleLevel;
  children?: React.ReactNode;
  onChangeValue: (value: RoleLevel) => void;
}



const RoleLevelInput: React.FC<Props> = ({
  isEditMode,
  onChangeValue,
  value,
  disabled,
  children
}) => {
  const { isElevateOrganization, observingMode } = useCurrentOrganization();
  
  const options = [...(isElevateOrganization && !observingMode ? [{
    id: RoleLevel.Elevate,
    title: 'Elevate',
    description: ''
  }] : []),
  {
    id: RoleLevel.Global,
    title: 'Global',
    description: 'Any roles setup at the global level will be available for all partners, distributors, employer, etc.'
  },{
    id: RoleLevel.Partner,
    title: 'Partner',
    description: 'Roles created at the partner level, will only be able to be accessed by that partner'
  }];
  if(!isEditMode) {
    return (
      <Box direction="row" justify='start'>
        <RoleLevelLabel level={value} /> 
      </Box>
    );
  }
  return (
    <Box direction="column">
      {options.map((option) => (
        <Box  key={option.id} margin={{bottom: 'm'}}>
          <RadioButton
            inputStyle={{
              alignItems: 'center'
            }}
            data-testid={`role_level_${option.id}_radio`}
            disabled={disabled}
            name={`level-picker_${option.id}`}
            onChange={() => {
              onChangeValue(option.id);
            }}
        
            label={(
              <Box direction='column' margin={{left: 'xxs'}} >
                <Text size="medium" weight={400}>
                  {option.title}
                </Text>
                <Text size="small" weight={500} color="textSecondary">
                  {option.description}
                </Text>
              </Box>
            )}
            checked={value === option.id}
          />
        </Box>
      ))}

      {value === RoleLevel.Partner ? 
        children
        : null} 
      
    </Box>
  );
};

export default RoleLevelInput;